import React from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import './ConfirmModal.css';

const DeleteUserModal = ({ onClose, onConfirm }) => {
  return (
    <div className="cm-overlay" onClick={onClose}>
      <div className="cm-modal" onClick={(e) => e.stopPropagation()}>

        <div className="cm-header">
          <div className="cm-icon cm-icon--danger">
            <AiOutlineDelete />
          </div>
          <div className="cm-title-group">
            <h3>Delete User</h3>
            <p>This action is permanent</p>
          </div>
          <button className="cm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="cm-body">
          <div className="cm-info-box cm-info-box--warn">
            <strong>Permanent deletion</strong>
            <p>This user and all associated data will be permanently removed. This cannot be undone.</p>
          </div>
        </div>

        <div className="cm-footer">
          <button className="cm-btn cm-btn--cancel" onClick={onClose}>Cancel</button>
          <button className="cm-btn cm-btn--danger" onClick={onConfirm}>Delete Permanently</button>
        </div>

      </div>
    </div>
  );
};

export default DeleteUserModal;
